import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { ReportsService } from 'app/modules/admin/transactions/inwards/reports.service';
import { AlertMessageService } from 'app/core/common/alert.message.service';
import { BaseRespone } from 'app/core/models/common.response';
import { Observable, Subject } from 'rxjs';
import { ReplacementCostService } from './replacement-cost.service';
import { ReplacementCost } from './replacement-cost.types';
import { map, take, takeUntil } from 'rxjs/operators';
import { InwardReport } from 'app/modules/admin/transactions/inwards/reports.types';
import { ReplacementCostDetailsComponent } from './details/replacement-cost-details.component';
import { SelectionModel } from '@angular/cdk/collections';


@Component({
    selector: 'app-replacement-cost',
    templateUrl: './replacement-cost.component.html',
    styleUrls: ['./replacement-cost.component.scss']
})
export class ReplacementCostComponent implements OnInit {

    @Input() report: InwardReport;
    @Input() reportId: number;
    @Input() reportType: string;
    selection = new SelectionModel<ReplacementCost>(true, []);
    totalArea: number = 0.00;
    total: number = 0.00;
    avg : number = 0.00;

    selectedReplacementCost: ReplacementCost;
    selectedIds: number[] = [];
    isAllSelectedCheckBox: boolean = false
    replacementCosts$: Observable<ReplacementCost[]>;

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    constructor(private _matDialog: MatDialog,
        private _matDialogRef: MatDialogRef<ReplacementCostComponent>,
        private _fuseConfirmationService: FuseConfirmationService,
        private _replacementCostService: ReplacementCostService,
        private _alertMessageService: AlertMessageService,
        @Inject(MAT_DIALOG_DATA)
        private _data: {
            report: InwardReport;
            reportId: number;
            reportType: string;
        }
    ) {
        this.report = _data.report;
        this.reportType = _data.reportType;
        this.reportId = _data.reportId;
    }

    ngOnInit(): void {

        this._replacementCostService.getReplacementCosts(this.reportId).subscribe((res) => {
            this.calculateSiteMeasurementsTotal();
        });

        this.replacementCosts$ = this._replacementCostService.replacementCosts$.pipe(map((data) => {
            data?.sort((a, b) => {
                return a.id < b.id ? -1 : 1;
            });
            return data;
        }));


        // Get the contact
        this._replacementCostService.replacementCost$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((contact: ReplacementCost) => {

                // Update the selected contact
                this.selectedReplacementCost = contact;

                // Mark for check
                //this._changeDetectorRef.markForCheck();
            });


        // if (this.replacementCosts.subscribe(re).length > 0) {
        //     this.calculateSiteMeasurementsTotal();
        // }

    }

    new(): void {
        let orderIndex = 0;
        this.replacementCosts$.subscribe(result => {
            orderIndex = result.length + 1;
        });

        this._matDialog.open(ReplacementCostDetailsComponent, {
            autoFocus: false,
            data: {
                replacementCost: {
                    orderIndex: orderIndex,
                    area: '',
                    cost: '',
                    rate: '',
                    reportId: this.reportId

                },
                reportType: this.reportType
            },
        }).afterClosed().subscribe((response) => {

        });
    }

    edit(replacementCost: ReplacementCost): void {
        this._matDialog.open(ReplacementCostDetailsComponent, {
            autoFocus: false,
            data: {
                replacementCost: replacementCost,
                reportType: this.reportType
            },
        }).afterClosed()
            .subscribe((response: BaseRespone<ReplacementCost>) => {
            });
    }


    /**
    * Delete the selected product using the form data
    */
    delete(id: number): void {
        // Open the confirmation dialog
        const confirmation = this._fuseConfirmationService.open({
            title: 'Delete ReplacementCost',
            message: 'Are you sure you want to remove? This action cannot be undone!',
            actions: {
                confirm: {
                    label: 'Delete'
                }
            }
        });

        // Subscribe to the confirmation dialog closed action
        confirmation.afterClosed().subscribe((result) => {
            // If the confirm button pressed...
            if (result === 'confirmed') {
                //Delete the product on the server
                this._replacementCostService.deleteReplacementCost(id).subscribe((res) => {
                    if (res.isSuccess) {
                        this._alertMessageService.success("ReplacementCost deleted successfully");
                    }
                    else {
                        this._alertMessageService.error(res.errors.join('\n'));
                    }
                });
            }
        });
    }

    async deleteSelectedRows() {
        const confirmation = this._fuseConfirmationService.open({
            title: 'Delete All ReplacementCost',
            message: 'Are you sure you want to remove? This action cannot be undone!',
            actions: {
                confirm: {
                    label: 'Delete'
                }
            }
        });

        const result = await confirmation.afterClosed().toPromise();

        if (result === 'confirmed') {
            const ids = this.selection.selected.map(item => item.id);
            const res = await this._replacementCostService.deleteAllReplacementCost(ids).toPromise();

            if (res.isSuccess) {
                this._alertMessageService.success("ReplacementCost all deleted successfully");
                this.selection.clear();
                this.replacementCosts$.subscribe()
            } else {
                this._alertMessageService.error(res.errors.join('\n'));
            }
        }
    }

    /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    calculateSiteMeasurementsTotal(): void {

        this._replacementCostService.replacementCosts$.subscribe(res => {
            this.totalArea = res.reduce((sum, current) => sum + current.area, 0);
            this.total = res.reduce((sum, current) => sum + current.cost, 0);
            if (res.length > 0) {

                this.avg = this.total/this.totalArea;
                // this.avg = res.reduce((sum, current) => sum + current.rate, 0) / res.length;
            } else {
                this.avg = 0.0;
            }

            //this.total = res.reduce((sum, current) => sum + current.cost, 0);
            //    // this.totalSuperBuiltUp = res.reduce((sum, current) => sum + current.siteSuperBuiltUp, 0);
        })
    }

    updateCheckedList(event, row) {
        this.replacementCosts$.pipe(take(1)).subscribe(measurements => {
            measurements.forEach(item => {
                if (item.id == row.id) {
                    item.selected = event.checked;
                    if (item.selected) {
                        this.selection.select(item); // Select item in selection model
                    }
                    else {
                        this.selection.deselect(item);
                    }
                }
            });

            this.isAllSelectedCheckBox = !measurements.some(a => !a.selected)

        });


    }


    selectAll(event: any) {
        const checked = event.checked;
        this.replacementCosts$.pipe(take(1)).subscribe((measurements: any[]) => {
            measurements.forEach((measurement) => {
                measurement.selected = checked;
            });
        });
    }
    checkboxLabel() {
        if (this.isAllSelected()) {
            return 'Deselect all';
        }
        if (this.selection.isEmpty()) {
            return 'Select all';
        }
        return `${this.selection.selected.length} selected`;
    }

    isAllSelected() {
        // Check if all measurements are selected
        return this.replacementCosts$.pipe(
            take(1),
            map(measurements => measurements.every(measurement => measurement.selected))
        );
    }


    toggleAllRows() {
        this.isAllSelected().subscribe(allSelected => {
            if (!allSelected) {
                // Select all items
                this.replacementCosts$.pipe(take(1)).subscribe(measurements => {
                    measurements.forEach(item => {
                        item.selected = true;
                        this.selection.select(item); // Select item in selection model
                    });
                });
                this.isAllSelectedCheckBox = true;
            } else {
                // Deselect all items
                this.replacementCosts$.pipe(take(1)).subscribe(measurements => {
                    measurements.forEach(item => {
                        item.selected = false;
                        this.selection.deselect(item); // Deselect item in selection model
                    });
                });
                this.isAllSelectedCheckBox = false;
            }
        });
    }

    onClose(): void {
        const returnValue = {
            // populate with your form data or any other data
            total : this.total,
            totalArea : this.totalArea,
            avg : this.avg,
        }
        this._matDialogRef.close(returnValue);
    }
}
